<template>
  <b-container class="text-center text-sm-left mt-2">
      <h3>Capture guide</h3>
      <p>This page will explain how you can capture the right images for your object.</p>
    <b-nav tabs v-b-scrollspy="config" class="my-sticky-top sticky-top">
      <b-nav-item href="#h4-0" @click="scrollIntoView">Camera</b-nav-item>
      <b-nav-item href="#h4-1" @click="scrollIntoView">Object</b-nav-item>
      <b-nav-item href="#h4-2" @click="scrollIntoView">Scene</b-nav-item>
      <b-nav-item-dd text="Images" right-alignment>
        <b-dd-item href="#h4-3" @click="scrollIntoView">Resolution</b-dd-item>
        <b-dd-item href="#h4-4" @click="scrollIntoView">Number</b-dd-item>
        <b-dd-divider></b-dd-divider>
        <b-dd-item href="#h4-5" @click="scrollIntoView">Examples</b-dd-item>
      </b-nav-item-dd>
      <b-nav-item href="#h4-6" @click="scrollIntoView">Files</b-nav-item>
      <b-nav-item href="#h4-7" @click="scrollIntoView">Upload</b-nav-item>
    </b-nav>

      <b-container
        id="nav-scroller"
        ref="content"
        class="mt-2 position-relative overflow-scroll"
      >
        <b-container v-html="guide"/>

        <b-container></b-container>
    </b-container>
  </b-container>
</template>

<script>
import guide_md from 'raw-loader!@/assets/guide.md'
import marked from 'marked'

import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.NavPlugin,
    bs.VBScrollspyPlugin
].forEach(p=> Vue.use(p))

function labelHeaders(html){
  let n = 0;
  return html.replace(/<h4[^>]*>/g, () => `<h4 id="h4-${n++}">`)
}

export default { 
    methods: {
      scrollIntoView(evt) {
          evt.preventDefault()
        const href = evt.target.getAttribute('href')
        const el = href ? document.querySelector(href) : null
        if (el)  window.scrollTo(0, el.offsetTop + this.config.offset) 
      }
    },
    data(){return {
        config:{offset:100},
        guide:labelHeaders(marked(guide_md))
    }}

}
</script>

<style>
.my-sticky-top {
    top: 3.5em;
    background: white;
    border-top:0.5em solid white;
}

</style>
